
// eslint-disable-next-line import/no-unresolved,import/extensions
import routeMixin from '~/mixins/routeMixin.js';
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingProductsChips',
  mixins: [routeMixin, respUtility],
  props: {
    filtersFromRoute: {
      type: Object,
    },
    currentFiltersBlock: {
      type: Array,
      default: () => [],
    },
    extraChips: {
      type: Array,
    },
    minPrice: {
      type: Number,
      default: 0,
    },
    maxPrice: {
      type: Number,
      default: 2000,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    customPrice() {
      return this.filtersFromRoute?.customPrice;
    },
    customPriceItem() {
      if (!this.customPrice) {
        return null;
      }
      const updatedItem = this.updatePriceLabel(this.customPrice);
      updatedItem.attrCode = 'price';
      return updatedItem;
    },
    selected() {
      return this.filtersFromRoute?.selected || {};
    },
    checked() {
      const keys = Object.keys(this.selected);
      const result = [];
      keys.forEach((attrCode) => {
        this.selected[attrCode].forEach((item) => {
          if (item.attrLabel) {
            const updatedItem = (attrCode === 'price') ? this.updatePriceLabel(item) : { ...item };
            updatedItem.attrCode = attrCode;
            result.push(updatedItem);
          }
        });
      });
      return result;
    },
    countChips() {
      const query = { ...(this.$route.query || {}) };
      delete query['per-page'];
      delete query['sort-by'];
      delete query.page;
      delete query.q;
      delete query.s;
      return Object.keys(query || {})
        .reduce((count, key) => count + (query[key]?.split('$,$') || []).length, 0);
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    removeChip(item) {
      if (item.attrCode === 'cat') {
        const catBlock = this.currentFiltersBlock.find((block) => block.attrCode === 'cat');
        if (catBlock) {
          const cat = catBlock.facets
            .some((facet) => facet.attrValue === item.attrValue
              && Array.isArray(facet.child) && facet.child.length > 0);
          if (cat) {
            const obj = { ...this.selected };
            if (Object.prototype.hasOwnProperty.call(obj, item.attrCode)) {
              delete obj[item.attrCode];
            }
            this.changeRouteFacets({
              selected: obj,
              customPrice: this.customPrice,
            });
            return;
          }
        }
      }
      const selectedItems = this.selected[item.attrCode]
        .filter((s) => s.attrValue !== item.attrValue);
      this.changeRouteFacets({
        selected: {
          ...this.selected,
          [item.attrCode]: selectedItems,
        },
        customPrice: this.customPrice,
      });
    },
    removeCustomPrice() {
      this.changeRouteFacets({
        selected: this.selected,
        customPrice: null,
      });
    },
    updatePriceLabel(item) {
      const updatedItem = { ...item };
      if (this.$store.state.pageData.type !== 'search') {
        updatedItem.attrLabel = updatedItem.attrLabel || updatedItem.attrValue;
        return updatedItem;
      }
      let min = item.from;
      let max = item.to;
      if ((!item.from && item.from !== 0) || item.from === '*' || item.from <= this.minPrice) {
        min = this.minPrice;
      }
      if ((!item.to && item.to !== 0) || item.to === '*' || item.to >= this.maxPrice) {
        max = this.maxPrice;
      }
      if (min !== item.from || max !== item.to) {
        updatedItem.attrLabel = `$${min} - $${max}`;
      }
      return updatedItem;
    },

  },
};
